export default __webpack_public_path__ + "static/media/zzz.657b13f1.gif";